import { initializeApp } from "firebase/app";
import { createContext, useEffect, useReducer, useState } from "react";
import { firebaseConfig } from "../util/FirebaseUtil";
import { doc, getDoc, getFirestore, onSnapshot } from "firebase/firestore";
import {
  getAuth,
  multiFactor,
  onAuthStateChanged,
  signInAnonymously,
} from "firebase/auth";

const AppContext = createContext({});

const liveStateReducer = (state, action) => {
  if (action.type === "merge") {
    return {
      ...state,
      ...action.data,
    };
  }

  if (action.type === "update") {
    return {
      ...state,
      [action.key]: action.value,
    };
  }

  return state;
};

const storedStateReducer = (state, action) => {
  if (action.type === "merge") {
    return {
      ...state,
      ...action.data,
    };
  }

  if (action.type === "update") {
    return {
      ...state,
      [action.key]: action.value,
    };
  }

  return state;
};

const AppProvider = (props) => {
  const [initialized, setInitialized] = useState(false);
  const [storedState, dispatchStoredAction] = useReducer(
    storedStateReducer,
    {}
  );
  const [liveState, dispatchLiveAction] = useReducer(liveStateReducer, {});
  const [firebaseStuff, setFirebaseStuff] = useState({});

  useEffect(() => {
    if (initialized) {
      localStorage.setItem("app_state", JSON.stringify(storedState));
    }
  }, [storedState]);

  useEffect(() => {
    console.log("Loading from localStorage");
    try {
      let existingData = JSON.parse(localStorage.getItem("app_state"));
      console.log("Found", existingData);
      if (existingData || true)
        dispatchStoredAction({
          type: "merge",
          data: { ...existingData },
        });
    } catch {}

    try {
      const firebaseApp = initializeApp(firebaseConfig);
      const firestoreDb = getFirestore(firebaseApp);
      const firebaseAuth = getAuth(firebaseApp);
      setFirebaseStuff({
        app: firebaseApp,
        db: firestoreDb,
        auth: firebaseAuth,
      });
      onAuthStateChanged(firebaseAuth, handleLoginChange);
      /*dispatchLiveAction({
        type: "update",
        key: "firebase",
        value: { app: firebaseApp, db: firestoreDb },
      });*/
    } catch {}

    setInitialized(true);
  }, []);

  const handleLoginChange = (user) => {
    if (user) {
      console.log("Logged in:", user);
      dispatchLiveAction({ type: "update", key: "uid", value: user.uid });
    } else {
      console.log("Logged out");
      dispatchLiveAction({ type: "update", key: "uid", value: null });
    }
  };

  useEffect(() => {
    if (firebaseStuff && firebaseStuff.userUnsub) firebaseStuff.userUnsub();
    if (liveState.uid && liveState.newUserDoc !== false) {
      console.log(liveState.uid);
      if (firebaseStuff && firebaseStuff.db) {
        getDoc(doc(firebaseStuff.db, "users", liveState.uid))
          .then(handleUserDocSnapshot)
          .catch((err) => {
            console.log(`Failed to update user information\n${err}`);
          });
        /*const unSub = onSnapshot(
          doc(firebaseStuff.db, "users", liveState.uid),
          handleUserDocSnapshot
        );
        setFirebaseStuff({ ...firebaseStuff, userUnsub: unSub });
        console.log("Added user snapshot");*/
      }
    }
  }, [liveState.uid, liveState.newUserDoc]);

  const handleUserDocSnapshot = (docSnap) => {
    console.log("Got user data from firebase");
    const userData = docSnap.data();
    if (userData.user_nickname)
      mergeLiveValues({
        user_nickname: userData.user_nickname,
        userDocExists: true,
        newUserDoc: false,
      });
  };

  const setStoredValue = (key, value) => {
    dispatchStoredAction({
      type: "update",
      key,
      value,
    });
  };

  const mergeStoredValues = (data) => {
    dispatchStoredAction({
      type: "merge",
      data,
    });
  };

  const setLiveValue = (key, value) => {
    dispatchLiveAction({
      type: "update",
      key,
      value,
    });
  };

  const mergeLiveValues = (data) => {
    dispatchLiveAction({
      type: "merge",
      data,
    });
  };

  const userOnline = liveState.uid && liveState.userDocExists;

  const contextData = {
    stored: storedState,
    live: liveState,
    derived: { user_online: userOnline },
    firebase: firebaseStuff,
    setStored: setStoredValue,
    mergeStored: mergeStoredValues,
    setLive: setLiveValue,
    mergeLive: mergeLiveValues,
  };

  return (
    <AppContext.Provider value={contextData}>
      {props.children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
